module.exports={
  message: {
    "Online Magazine": '飞云杂志',
    "Browse Occupations":'职业',
    "Find An Opportunity":"就业机会",
    "Qualifications":"Qualifications",
    "Self Assessment":"Self Assessment",
    "Home":"主页",
    "Job detail":"Job detail",
    "Browse Courses":"课程",
    "Year":" 年 ",
    "Month":" 月 ",
    "Day":" 日 ",
    "monthsAgo":" 个月前",
    "weeksAgo":" 周前",
    "daysAgo":" 日前",
    "dayAgo":" 日前",
    "today":"  当日",
    "OccupationTitleSkillOrIndustry":"职业名称，技能或行业",
    "All Education Level":"所有教育程度",

    "Requirement":"入职要求",
    "Experience":"工作经验",
    "EducationLevel":"教育程度",
    "Skills":"技能",
    "outLook":"前景",
    "CareerPath":"晋升途径",
    "Common Skills":"常见技能",
    "Growing Skills":"高增长技能",
    "Manpoweroutlook":"就业前景",
    "Automationpotential":"自动化可能性",
    "Private Sector":"私人机构",
    "Government Sector":"政府部门",
    "To know more":"想知更多",
    "Share with":"分享到",
    "RelatedJobOpportunities":"相关职位空缺",
    "Opportunities":"机会",
    "RelatedCourses":"相关课程",
    "QR Courses":"资历名册课程",
    "MOOC Courses":"大众开放在线课程（MOOC）",
    "View all opportunities":"所有相关职位空缺",
    "View all qualifications":"所有相关课程",
    "Related Job functions":"相关职能：",
    "Discover career resources for educators and employers":"获取更多有关培训和职业发展的资料",
    "link":"[此]",
    "forStart":" 「",
    "for":'的',
    "forEnd":'」 ',
    "Low":"低",
    "High":"高",
    "Show more":"显示更多",
    "Show less":"显示更少",
    "Monthly salary":"月薪",
    "All Job Functions":"所有工作种类",
    "Find a Job Opportunity":"职位空缺",
    "Career quizzes":"职业小测试",
    "Hot Picks":"热门文章",
    "hotPicks":"热门",
    "Top 5 searches":"热门搜寻",
    "View all":"所有职业",
    "FInd out more":"探索",
    "Stay":"助你找寻新工作，让事业向前迈进。",
    "Job title, company name or skill, etc":"工作名称，公司名称或技能等",
    "Job Functions":"工作种类",
    "Search":"搜寻",
    "Learning and Upskilling":"学习与自我增值",
    "Learn from":"持续学习，装备自己—寻找适合你的全日制、兼读和网上课程",
    
    "What careers would suit you?":"什么职业最适合你？",
    "Various career":"助你探索林林总总职业的多个小测试，根据你的兴趣和才能为你介绍合适的职业",
    "Take a quiz":"参加小测试",
    "Resources":"资源中心",
    "Feedback":"意见回馈", 
    "About Human":"关于人力资源规划委员会",
    "About Us":"关于我们",
    "Privacy Policy":"私隐政策",
    "Disclaimer":"免责声明",
    "© 2019":" talent.gov.hk 将保留一切权利。",
    "Self-Assessment":"小测试",
    "developmentTip":"This section is under development. Please ignore. ",
    "FT":"全日制",
    "PT":"兼读制",
    "DL":"遥距学习",
    "EL":"网上/移动学习",
    "Not Applicable":"不适用",
    "siteMap":"网页导览指南",
    "CourseInputTip":"课程名称、机构、技能等",
    "All Areas of Study":"所有学科",
    "CEF":"CEF可获发还款项课程",
    "All Learning Modes":"所有学习模式",
    "All Course Providers":"所有课程提供机构",
    "Fewer Options":"更少选项",
    "More Options":"更多选项",
    "results":"搜寻结果",
    "item":"项",
    "QR number:":"资历名册课程编号:",
    "Course Provider":"课程营办者",
    "Area of Study":"学习及培训范畴",
    "Learning mode":"授课模式",
    "Level":"级别",
    "Pace of learning":"学习步伐",
    "Effort":"所需时数",
    "Length":"修业期",
    "What youll learn":"学习要点",
    "Requirements":"职位要求",
    "Prerequisites":"课程需求",
    "Go to course page":"前往课程网站",
    "QR level 1-3":"基础证书／文凭",
    "QR level 4":"高级证书／高级文凭／副学士",
    "QR level 5":"学士或同等资历",
    "QR level 6":"深造文凭／深造证书／硕士",
    "QR level 7":"博士",
    "All Level of Positions":"所有年资",
    "All Job Types":"所有受雇形式",
    "Organization":"公司名称",
    "Job function(s)":"工作种类",
    "Department":"部门",
    "Level of position":"年资",
    "Salary":"薪酬",
    "Job descriptions":"工作简介",
    "Job duties":"职责",
    "Advertising date":"刊登日期",
    "All Level":"所有课程级别",
    "Show more":"显示更多",
    "Show less":"显示更少",
    "Apply on":"前往",
    "Apply on2":"申请",
    "Apply":"申请",
    "Other Job Opportunities":"其他工作机会",
    "ViewAll":"显示更多",
    "jobTAndC":"為方便用戶 ，talent.gov.hk 提供由其他網站整合的職位空缺資訊及相關連結。talent.gov.hk對這些網站提供的内容不負有任何責任。",
    "EffortTip1":"每周",
    "EffortTip2":"小时",
    "week(s)":"周",
    "noSearchResult":"没有相关的搜寻结果。",
    "Category":"类别",
    "Feature story":"专访",
    "Side story":"专题",
    "Column":"专栏",
    "All":"全部",
    "Careers Exploration":"职业探索", 
    "Vacancies Search":"空缺搜寻",
    "All articles":"所有文章",
    "on this page":"这页可找到",
    "skillTips":"小提示:  按下个别技能，马上搜寻相关课程。",
    "Relevant links":"相关连结",
    "assessmentDesc":"助你探索林林总总职业的多个小测试，根据你的兴趣和才能为你介绍合适的职业。",
    "Skill-Career Quiz":"技能职业小测试",
    "Interest-Career Quiz":"兴趣职业小测试",
    "Background-Career Quiz":"背景职业小测试",
    "getStarted":"立即开始",
    "skillDesc":"发挥你的专长。这个小测试助你快捷地寻找与你才能相应的职业。",
    "skillContent1":"透过回答简单问题，告诉我们哪些是您已有、或者有兴趣学习的的技能及知识。",
    "skillContent2":"我们会从资料库中寻找与你的技能最接近的职业。回答首六条问题后，小测试会开始建议一系列职业。",
    "skillContent3":"你可以点按个别职业，以进一步了解不同职业的详情。",
    "Start":"开始",
    "interestDesc1":"透过了解你的工作兴趣，这个小测试可以助你探索或会喜欢并且有满足感的工作。",
    "interestDesc2":"这个小测试沿用",
    "interestDesc3":"<a target='_blank' href='https://www.onetcenter.org/tools.html'>O*NET Mini Interest Profiler</a> ",
    "interestDesc4":"，包含30条你对不同工作活动喜好程度的问题。小测试会从资料库中寻找与你的兴趣最接近的职业。",
    "interestDesc5":"回答首六条问题后，小测试会开始建议一系列可能与你兴趣匹配的职业。你可以随时点按个别职业，以进一步了解不同职业的详情。",
    "interestDesc6":"请仔细阅读题目，并选择你对每一项活动感兴趣的程度：",
    "Strongly Dislike":"非常不喜欢",
    "Dislike":"不喜欢",
    "Unsure":"不确定",
    "Like":"喜欢",
    "Strongly Like":"非常喜欢",
    "interestDesc7":"你只需要考虑你喜欢或不喜欢做这些工作，而无须考虑你是否有足够学历或训练从事这些工作，又或者是这些工作会有多少收入等等。",
    "interestDesc8":"答案没有对错，而这小测试并没有限时，你可以慢慢回答问题。",
    "backgroundDesc":"尝试透过这个小测试，了解与你的学历和工作经验相符的职业!",
    "Q":"问",
    "Your Career Matches":"你的职业配对",
    "resultTip":"结果将于回答六条题目后出现。",
    "Show result":"显示结果",
    "Your highest education attained:":"你的最高学历：",
    "Years of working experience:":"你的工作年资：",
    "Your field of study:":"你的主修科目：",
    "studyNote":"(「你的主修科目」主要是指专上教育的修读科目。如果你并没有就读过任何专上教育课程，你可以选择一项你希望在未来就读的科目。）",
    "Your current occupation:":"你现时的职业：",
    "NoMatchingResults":"没有匹配结果。",
    "Issue":"期号",
    "Number":"数字",
    "Years":"年",
    "Field of study":"主修科目",
    "Job title":"职业",
    "Try another quiz":"试试其他小测试",
    "Log in Facebook to view comments":"登入Facebook去显示留言",
    "Feature Articles":"专题文章",
    "Columns":"专栏",
    "The Headline":"飞云头条",
    "View Comments":"显示留言",
    "Read more:":"阅读更多",
    "Recommended articles":"推介文章",
    "Related Occupations":"相关职业",
    "Published:":"发布于",
    "Select Issue":"选择期刊",
    "Feature articles":"专题文章",
    "feedbackDesc":"多谢浏览 talent.gov.hk！我们欢迎你宝贵的意见，请填写并提交以下表格(带星号（*）的字段表示必须输入)。",
    "sendSuccess":"你的意见已送出。感谢！",
    "Email":"电邮",
    "Types of user":"用户类型",
    "Student":"学生",
    "Job seeker":"求职者",
    "Employee":"雇主",
    "Employer":"雇员",
    "CareerEducationCounsellor":"职业/培训顾问",
    "Others":"其他",
    "Age group":"年龄级别",
    "Below 18":"18岁以下",
    "60 or above":"60岁或以上",
    "Type of feedback":"意见类型",
    "Enquiries":"查询",
    "Outdated inaccurate information":"资料更正",
    "Suggestions and recommendations":"意见提供",
    "Collaboration opportunities":"合作机会",
    "Related Page":"相关页面",
    "Contact information":"联络资料",
    "Feedback form":"意见",
    "Message":"讯息",
    "Please enter message":"请填写讯息",
    "Submit":"提交",
    "Welcome Talent":"欢迎浏览talent.gov.hk",
    "Talent information":"talent.gov.hk是香港特别行政区政府人力资源规划委员会设立的资讯平台，提供综合的人力资讯，以协助公众在职业、进修及发展路向上作出明智抉择。",
    'Explorer':'「飞云」是talent.gov.hk旗下的网上月刊，涵盖与职场相关的热门话题。',
    "Membership and Terms of Reference":"HRPC成员名单及职权范围",
    "HRPC Information Centre":"HRPC资讯中心",
    "Press Release":"新闻稿",
    "Archive":"资料库",
    "Contact Us":"联络我们",  
    "Address":"地址",
    "Telephone number":"电话号码",
    "Please enter your email":"请输入电邮地址",
    "Please select the type of user":"请选择用户类型",
    "Please select the age group":"请选择年龄组别",
    "Please select type of feedback":"请选择意见类型",
    "Feature stories":"专题文章",
    "Human Resources Planning Commission":"人力资源规划委员会",
    "Email:":"电邮： ",
    "hrpc@cso.gov.hk":"hrpc@cso.gov.hk",
    "Address:":"地址： ",
    "Human Resources":"人力资源规划委员会秘书处香港添马添美道2号政府总部东翼26楼",
    "Telephone:":"电话： ",
    "Fax:":"传真： ",
    "2810 2586":"2810 2586",
    "2537 7068":"2537 7068",
    "ReratedCourses":"课程",
    "Slide to view more":"滚动去看看",
    "CEF_text":'持续进修基金(CEF)为有志进修的成年人提供持续教育和培训资助。报读已登记成为基金课程的持续教育和培训课程，才符合申请发还课程款项的资格。有关申请手续及基金课程的名单，请浏览[link]',
    "CEF_link_text":"基金网页",
    "CEF_link":"https://www.wfsfaa.gov.hk/cef/sc/index.htm",
    "QR_text":'[link]是由教育局局长根据《学术及职业资历评审条例》设立，以载列获资历架构认可的资历。根据该条例，香港学术及职业资历评审局被指定为资历名册当局以发展和管理资历名册。',
    "QR_link_text":"资历名册",
    "QR_link":"https://www.hkqr.gov.hk/HKQRPRD/web/hkqr-sc/index.html",
    "MOOC_text":'由edX提供的大规模开放在线课程。',
    "Copied link to clipboard":"已复制链结！",
    "Close":"关闭",
    "Beta Version":"测试版",
    "Powered by":"资料由以下提供",
    "QF level":"QF 级别 ",
    "Discover more career resources":"发现更多职业资源",
    "There are no":"没有相关的搜寻结果。",
    "description":"talent.gov.hk囊括逾2万个政府及私人职位空缺、3百多种职业简介及上万个课程，助你找到理想职业及提升技能！关于我们：talent.gov.hk是香港特别行政区政府人力资源规划委员会设立的信息平台，提供综合的人力信息，以协助公众在职业、进修及发展路向上作出明智抉择。",
    'mateMagezine':"飞云杂志",
    "benefits":"待遇",
    "location":"工作地点",
    "There are (number) jobs for you":"为你提供(number)份工作。",  
    "Choose a job for more details!":"点击左列的工作，查看详情！",
    "Explorer_talent":"飞云杂志 - talent.gov.hk - 一站式人力资源资讯平台",
    "Explorer_desc":"「飞云」是talent.gov.hk旗下的网上杂志，涵盖与职业、技能提升及职场相关的热门话题",
    "Explorer_title":"飞云杂志",
    "Featured Jobs":"热门职位空缺",
    "View all Featured Jobs":"所有空缺",
    "View all Occupation":"所有职业",
    "Popular Courses":"热门课程",
    "View all Popular Courses":"所有课程",
    "Career Magazine": "飞云杂志",
    "Hot Occupations": "热门职业",
    "Discover": "探索",
    "browseOccupations": "职业探索",
    "findJob": "空缺搜寻",
    "browseCouses": "浏览课程",
    "careerQuizzes": "职业小测试",
    "browseOccupations_text": "逾300个职业专页助你了解发展机会。",
    "findJob_text": "政府及私人职位空缺资料库助你寻找理想工作。",
    "browseCouses_text": "逾万个课程助你提升技能及资歴。",
    "careerQuizzes_text": "小测试助你探索配合自己兴趣、技能及经验的职业。",
    "View all occupations": "所有职业",
    "View all findJob": "所有职位空缺",
    "View all browseCouses": "所有课程",
    "View all careerQuizzes": "参加小测试",
    "Let get started": "了解更多",
    "Discover Description": "透过我们的工具探索你的职业路向、进修选择及工作机会。",
    "Default Page Title": "一站式人力资源资讯平台",
    "Careers_title":"职业探索",
    "Careers_desc":"在这里探索你的理想职业！数据库介绍逾300种职业，内容包括职业介绍、所需技能、入职要求及就业前景等，同时亦提供相关职位空缺及课程等信息",
    "Courses_desc":"浏览上万个学习及技能提升课程，数据库涵盖本港资历名册进修课程及海外网络开放式课程，亦可同时搜寻持续进修基金(CEF)可获发还款项课程信息",
    "Courses_title": " - 课程 - talent.gov.hk",
    "Job_desc": "转载超过2万个政府及私人职位空缺，日日更新全职兼职好工，立即搜寻！",
    "Job_title": " - 职位空缺 - talent.gov.hk",
    "Self-Assessment_title":"职业小测试",
    "Self-Assessment_desc":"talent.gov.hk 提供三个根据你的技能、兴趣、职业背景作评估的小测试，助你探索适合的职业",
    "Default Keywords": "求職, job searching, 技能提升, upskilling,職業資訊, career exploration, 職業小測試, career quizzes, 招聘, jobs, 搵工, 職位空缺, vacancies,兼職, part time, 職位, 全職, full time, 散工, 就業, 政府工, Gov jobs, 持續進修基金, CEF, 持續進修, learning,課程 courses, 創業, startup, 大灣區, Greater Bay Area, 人力資源, human resources, manpower",
    "Explorer_Keywords": "求職, job searching, 技能提升, upskilling,職業資訊, career exploration, 招聘, jobs, 搵工, 職位空缺, vacancies, 就業, 政府工, Gov jobs, 持續進修基金, CEF, 持續進修, learning,課程 courses, 創業, startup, 職業雜誌, career magazine, 大灣區, Greater Bay Area, 飛雲, 機會嚟喇, 人力資源, human resources, manpower",
    "Careers_keywords": "求職, job searching, 技能提升, upskilling,職業資訊, career exploration, 招聘, jobs, 搵工, 職位空缺, vacancies, 就業, 政府工, Gov jobs, 創業, startup, 職業生涯規劃, career planning, 工作經驗, experience, 入職要求, requirement, 教育程度, education level, 技能, skills, 就業前景, employment outlook, 自動化可能性, automation potential, 晉升途徑, career path",
    "Courses_keywords": "課程資訊, course exploration,  持續進修基金, Continuing Education Fund, CEF, 持續進修, 進修,  learning,課程, courses, 技能, skills, 技能提升, upskilling, 再培訓, retraining, 增值, 證書, certificate",
    "Job_keywords": "hong kong jobs, recruit, salary, 搵工, 求職, 招聘, find job, government job, 政府工, 職位空缺, 就業, job searching, vacancies, 全職, 兼職, full time, part time",
    "Self-Assessment_keywords": "技能測試, 興趣測試, 職業背景測試, skill assessment, interest assessment, background assessment, career assessment, career quiz, career test, 職業測試, 職業評估, Holland test, 職涯規劃",
    "View all QR Courses": "所有资历名册课程",
    "View all MOOC Courses": "所有MOOC课程",
    "Entry level": "初级职位",
    "Part time": "兼职",
    "Government vacancies": "政府职位空缺",
    "Job Creation Scheme": "创造职位计划",
    "Instant-filter": "快速搜索",
    "min":"分钟",
    "hour":"小时",
    "s":"",

  }
}